"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function RecentChroniclesConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4 animate-pulse">
            <AspectRatio ratio={2 / 3} className="bg-muted rounded-none overflow-hidden" />
            <div className="space-y-2">
              <div className="h-5 bg-muted rounded-none w-3/4"></div>
              <div className="h-4 bg-muted rounded-none w-1/2"></div>
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 border border-destructive/20 rounded-none bg-destructive/5">
        <p className="text-destructive mb-4">Impossibile caricare i post dei corsi.</p>
        <Button variant="outline" onClick={() => window.location.reload()}>Riprova</Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>Nessun corso disponibile al momento.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
      {posts.map((post, i) => {
      const chapterMatch = post.title.match(/\d+/);
      const chapterText = chapterMatch ? `MOD. ${chapterMatch[0]}` : "INFO";
      const releaseDate = post.date ? new Date(post.date).toLocaleDateString('it-IT', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      }) : "Disponibile ora";
      return <div key={post.id} data-index={i} className="flex flex-col gap-4 group">
            <Link to={post.link || "#"} className="block relative overflow-hidden rounded-none bg-card ring-1 ring-border transition-all duration-300 hover:ring-primary hover:shadow-md">
              <AspectRatio ratio={2 / 3}>
                {}
                <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585744/img/formazione_professionale.png"} alt={post.title} className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                
                {}
                <div className="absolute inset-0 pointer-events-none z-10 opacity-10 mix-blend-multiply" style={{
              backgroundImage: 'repeating-linear-gradient(90deg, transparent, transparent 1px, #000 1px, #000 2px)'
            }} />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/80 via-transparent to-transparent z-10" />

                {}
                <div className="absolute inset-0 flex items-center justify-center bg-primary/90 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20 backdrop-blur-none">
                  <span className="text-2xl md:text-3xl font-bold text-primary-foreground scale-90 group-hover:scale-100 transition-transform duration-300 font-default tracking-tight">
                    {chapterText}
                  </span>
                </div>
              </AspectRatio>
            </Link>
            
            <div className="flex flex-col gap-1 px-1">
              <h3 className="text-foreground font-bold text-lg md:text-xl font-default line-clamp-1 group-hover:text-accent transition-colors duration-300">
                <Link to={post.link || "#"}>{post.title}</Link>
              </h3>
              <p className="text-muted-foreground text-xs uppercase tracking-widest font-mono">
                {releaseDate}
              </p>
            </div>
          </div>;
    })}
    </div>;
}
export default function RecentChronicles() {
  const wp_query_params = {
    post_type: "post",
    per_page: 50,
    order: "desc",
    orderby: "date",
    tax_query: [{
      taxonomy: "category",
      field: "slug",
      terms: "corsi"
    }]
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}